import { zod } from '@acme/core'
import { z } from 'zod'
import ApiService from '../api.service'
import { FuncionarioCentroCusto } from './funcionario'

export const CreateCentroCustoSchema = zod.CentroCustoSchema.pick({
    nomeCentroCusto: true,
    codigo: true,
    empresaId: true,
    predecessorId: true,
}).extend({
    nomeCentroCusto: z
        .string()
        .min(1, 'O nome deve conter ao menos um caractere')
        .max(100, 'O nome deve ser menor que 100 caracteres'),
})

export type CreateCentroCustoOutput = z.infer<typeof CreateCentroCustoSchema>

export type CreateCentroCustoV2 = CreateCentroCustoOutput & {
    children?: CreateCentroCustoOutput[]
}

export const UpdateCentroCustoSchema = zod.CentroCustoSchema.pick({
    id: true,
    nomeCentroCusto: true,
    codigo: true,
    empresaId: true,
    predecessorId: true,
})
    .partial()
    .required({ id: true })

export type UpdateCentroCustoOutput = z.infer<typeof UpdateCentroCustoSchema>
export type CentroCusto = z.infer<typeof zod.CentroCustoSchema>
type QueryParams = {
    empresaId: number
}

export const centroCusto = new ApiService<
    CreateCentroCustoOutput,
    CentroCusto & { FuncionarioCentroCusto?: FuncionarioCentroCusto[] },
    QueryParams
>('centro-custos')

export const centroCusto_v2 = new ApiService<CreateCentroCustoV2, CentroCusto>(
    'centro-custos',
    'v2',
)
